import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Spin } from 'antd';
import ENVIRONMENT from "../../../../environments";

export default function ShopifyCallback() {
  const [status, setStatus] = useState('Authorizing...');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shop = params.get("shop") || localStorage.getItem("shop");
    const hmac = params.get("hmac") || localStorage.getItem("hmac");
    const code = params.get("code") || localStorage.getItem("code");
    const state = params.get("state");
    const jwtToken = localStorage.getItem("all3d_jwt_token");

    if (!shop || !code || !hmac) {
      setError('Missing query parameters.');
      setLoading(false);
      return;
    }

    if (!jwtToken) {
      console.log("No portal user found — redirecting to login.");
      // Redirect to your portal login, passing shop so you can continue later
      localStorage.setItem('shop', shop);
      localStorage.setItem('hmac', hmac);
      localStorage.setItem('code', code);
      window.top.location.href = `${ENVIRONMENT.PORTAL_LINK}?shop=${shop}`;
      setLoading(false);
      return;
    }

    const handleCallback = async () => {
      try {
        const res = await axios.post(ENVIRONMENT.SHOPIFY_CALLBACK, {
          shop,
          code,
          hmac,
          state,
          customer_username: localStorage.getItem('username'),
        });

        if (res.status === 200) {
          setStatus('App installed successfully!');
          localStorage.removeItem('shop');
          const redirectUrl = `${ENVIRONMENT.PORTAL_LINK}integrations`;
          window.top.location.href = redirectUrl;
          localStorage.setItem('shopify_authorized', 'true');
        } else {
          setError('Authorization failed.');
        }
      } catch (err) {
        console.error(err);
        setError('Server error during authorization.');
      }
      setLoading(false);
    };

    handleCallback();
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      {loading ? <Spin size="large" /> : status}
    </div>
  );
}
